import LniIsolatedWorkersComplaint from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form';
export default [
    LniIsolatedWorkersComplaint,
];